import apiClient from './apiClient';

export interface Breed {
  _id: string;
  name: string;
  slug: string;
  petCategory: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

class BreedsService {
  async getBreeds(categoryId?: string, includeInactive = false) {
    const params = new URLSearchParams();
    if (categoryId) params.set('category', categoryId);
    // includeInactive → isActive=all so the admin list shows disabled breeds too.
    if (includeInactive) params.set('isActive', 'all');
    const qs = params.toString();
    const response = await apiClient.get(`/breeds${qs ? `?${qs}` : ''}`);
    return response.data;
  }

  async getBreedById(id: string) {
    const response = await apiClient.get(`/breeds/${id}`);
    return response.data;
  }

  async createBreed(data: Partial<Breed>) {
    const response = await apiClient.post('/breeds', data);
    return response.data;
  }

  async updateBreed(id: string, data: Partial<Breed>) {
    const response = await apiClient.put(`/breeds/${id}`, data);
    return response.data;
  }

  async toggleBreedStatus(id: string) {
    const response = await apiClient.patch(`/breeds/${id}/toggle-status`);
    return response.data;
  }

  async deleteBreed(id: string) {
    const response = await apiClient.delete(`/breeds/${id}`);
    return response.data;
  }
}

export const breedsService = new BreedsService();
export default breedsService;

